var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfusedFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 37.9565 3.1607 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.1607 37.9565 0 30 0C22.0435 0 14.4129 3.1607 8.7868 8.7868C3.1607 14.4129 0 22.0435 0 30V30Z",
    fill: "#FACB56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C24.0666 0 18.2664 1.75947 13.3329 5.05591C8.39943 8.35235 4.55426 13.0377 2.28363 18.5195C0.0129984 24.0013 -0.581101 30.0333 0.576455 35.8527C1.73401 41.6721 4.59123 47.0176 8.78681 51.2132C12.9824 55.4088 18.3279 58.266 24.1473 59.4236C29.9667 60.5811 35.9987 59.987 41.4805 57.7164C46.9623 55.4458 51.6477 51.6006 54.9441 46.6671C58.2405 41.7336 60 35.9334 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.1607 37.9565 0 30 0ZM30 55.5C24.5857 55.5 19.2931 53.8945 14.7913 50.8865C10.2895 47.8785 6.78076 43.6031 4.70881 38.601C2.63686 33.5988 2.09475 28.0946 3.15102 22.7844C4.20729 17.4742 6.8145 12.5964 10.643 8.76795C14.4714 4.93949 19.3492 2.33227 24.6594 1.276C29.9696 0.219733 35.4738 0.761849 40.476 2.8338C45.4781 4.90575 49.7535 8.41447 52.7615 12.9163C55.7695 17.4181 57.375 22.7107 57.375 28.125C57.375 35.3853 54.4909 42.3482 49.3571 47.482C44.2232 52.6158 37.2603 55.5 30 55.5Z",
    fill: "#F3BC31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9561 8.63403C20.9561 9.23077 21.9043 9.80307 23.5921 10.225C25.2799 10.647 27.5691 10.884 29.9561 10.884C32.343 10.884 34.6322 10.647 36.32 10.225C38.0078 9.80307 38.9561 9.23077 38.9561 8.63403C38.9561 8.0373 38.0078 7.465 36.32 7.04304C34.6322 6.62109 32.343 6.38403 29.9561 6.38403C27.5691 6.38403 25.2799 6.62109 23.5921 7.04304C21.9043 7.465 20.9561 8.0373 20.9561 8.63403Z",
    fill: "#F1E678"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7501 37.5C51.7501 38.745 50.0701 39.75 48.0001 39.75C45.9301 39.75 44.2501 38.745 44.2501 37.5C44.2501 36.255 45.9301 35.25 48.0001 35.25C50.0701 35.25 51.7501 36.255 51.7501 37.5Z",
    fill: "#FFCC4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25006 37.5C8.25006 38.745 9.93006 39.75 12.0001 39.75C14.0701 39.75 15.7501 38.745 15.7501 37.5C15.7501 36.255 14.0701 35.25 12.0001 35.25C9.93006 35.25 8.25006 36.255 8.25006 37.5Z",
    fill: "#FFCC4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9067 25.6052L19.8458 32.5443",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8458 25.6052L12.9067 32.5443",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1164 25.6052L40.1773 32.5443",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1773 25.6052L47.1164 32.5443",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0455 19.1519C14.251 18.3397 15.759 17.8983 17.313 17.9029C18.866 17.9034 20.3719 18.3442 21.5805 19.1519",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9777 18.666C45.7819 17.8538 44.2862 17.4125 42.7448 17.417C41.2045 17.4176 39.7108 17.8583 38.512 18.666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7355 44.9739C18.7355 47.9576 19.9208 50.819 22.0306 52.9288C24.1404 55.0386 27.0018 56.2239 29.9855 56.2239C32.9692 56.2239 35.8307 55.0386 37.9405 52.9288C40.0503 50.819 41.2355 47.9576 41.2355 44.9739C41.2355 41.9902 40.0503 39.1287 37.9405 37.0189C35.8307 34.9091 32.9692 33.7239 29.9855 33.7239C27.0018 33.7239 24.1404 34.9091 22.0306 37.0189C19.9208 39.1287 18.7355 41.9902 18.7355 44.9739Z",
    fill: "#FFB0CA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 50.5C21 51.9587 21.9482 53.3576 23.636 54.3891C25.3239 55.4205 27.6131 56 30 56C32.3869 56 34.6761 55.4205 36.364 54.3891C38.0518 53.3576 39 51.9587 39 50.5C39 49.0413 38.0518 47.6424 36.364 46.6109C34.6761 45.5795 32.3869 45 30 45C27.6131 45 25.3239 45.5795 23.636 46.6109C21.9482 47.6424 21 49.0413 21 50.5Z",
    fill: "#FF866E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfusedFace);
export default __webpack_public_path__ + "static/media/confused-face.2aa7a45bab21cb15345de24a5ba0d247.svg";
export { ForwardRef as ReactComponent };